<script>

import Multiselect from 'vue-multiselect'
import { euroCouponsThirdpartyMethods, authComputed } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EuroCouponsThirdpartySelector',
  components: {
    Multiselect, 

  },
  props: {
    value: {
      required: false,
      default: ()=>(''),
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    description : {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      euroCouponsThirdpartyOptions: [],
      loadingEuroCouponsThirdpartyOptions: false,
      euroCouponsThirdpartyOptionsMounted: true,
      euroCouponsThirdpartyOptionsCache: []
    }
  },
  computed: {
    ...authComputed,
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  mounted: function () {
    let context = this
    let user_info = context.currentSession.user.user_info
    const is_thirdparty_user = user_info.is_thirdparty_user
    if (is_thirdparty_user === false) {
      context.populateEuroCouponsThirdpartyOptions()
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,

    populateEuroCouponsThirdpartyOptions(searchQuery){
      let context = this
      context.loadingEuroCouponsThirdpartyOptions = true
      let reqParams = context.$select_params(searchQuery)
      const promise = context.fetchEuroCouponsThirdpartyOptions(reqParams)
      return promise.then(data => {
          let listOptions = []
          data.results.forEach(opt => {
              listOptions.push({
                  'id': opt.id,
                  'name': opt.name || opt.id
              })
          });
          context.euroCouponsThirdpartyOptions = listOptions
          context.loadingEuroCouponsThirdpartyOptions = false
          context.euroCouponsThirdpartyOptionsMounted = true
      }).catch(error => {
          context.$axios_error_noty(error, context)
          context.loadingEuroCouponsThirdpartyOptions = false
          context.euroCouponsThirdpartyOptionsMounted = true
      })
    },

    asyncFindEuroCouponsThirdparty: _.debounce(function (searchQuery) {
        this.populateEuroCouponsThirdpartyOptions(searchQuery)
    }, 600),

    labelOfEuroCouponsThirdparty(opt){
      let context = this
      let optionFound = context.euroCouponsThirdpartyOptions.find(x => x.id === opt)
      if (!optionFound){
          let cacheFound = context.euroCouponsThirdpartyOptionsCache.find(x => x.id === opt)
          return  cacheFound ? cacheFound.name : context.euroCouponsThirdpartyOptionsMounted ? `${ 'label_not_found' }: ${opt}`: ''
      }else{
          if (context.inputVal === opt){
              if (!context.euroCouponsThirdpartyOptionsCache.find(x => x.id === opt)){
                  context.euroCouponsThirdpartyOptionsCache.push(optionFound)
              }
          } 
          return optionFound.name
      }
    },
    
  },
}
</script>

<template>
  <b-container class="p-0">

    <b-form-group :label="$t(`thirdparty`)" :description="description">
      <b-row>
        <b-col :md="12">
          <Multiselect
              v-model="inputVal"
              :multiple="multiple"
              :options="euroCouponsThirdpartyOptions.map(x => x.id)" 
              :custom-label="opt => labelOfEuroCouponsThirdparty(opt)"
              :loading="loadingEuroCouponsThirdpartyOptions"
              :internal-search="false"
              :selected-label="$t('selected')"
              :select-label="$t('press_enter_to_select')"
              :deselect-label="$t('press_enter_to_remove')"
              :placeholder="$t('select_option')"
              @search-change="asyncFindEuroCouponsThirdparty">
          </Multiselect>
        </b-col>
      </b-row>
    </b-form-group>

  </b-container>
</template>
<style lang="scss">
.multiselect__tags {
	min-height: 38px;
	display: block;
	max-height: 30px;
	padding: 6px 40px 0 8px;
	border-radius: 5px;
	border: 1px solid #0570a7;
	background: #fff;
	font-size: 14px
}
</style>